import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-a-small', 'IconLetterASmall', [
  ['path', { d: 'M10 16v-6a2 2 0 1 1 4 0v6', key: 'svg-0' }],
  ['path', { d: 'M10 13h4', key: 'svg-1' }],
]);
